module.exports = __webpack_public_path__ + "static/media/PM.e7bd2250.svg";